import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import '../../components/Dealers/Dealers.css';
import DealerEdit from '../../components/Dealers/DealerEdit';
import capitaliseSentence from '../../utils/CapitaliseSentence';
import Toolbar from '../../components/Header/Toolbar/Toolbar';

class DealerEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealer: props.location.state.dealer,
      authToken: localStorage.getItem('authToken'),
    };
    this.BackToDealer = this.BackToDealer.bind(this);
  }

  BackToDealer() {
    this.props.history.push({
      pathname: '/',
    });
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
          <Toolbar />
        </div>
        <div className="container-fluid text-center">
          <div className="dealerUpperHeader">
            <button className="btn btn-primary" onClick={this.BackToDealer}>
              Back to Dealers
            </button>
          </div>

          <LowerHeader pageTitle="Edit dealer" />

          {/* Dealer Address */}
          <div className="dealerAddressWrapper">
            <span className="dealerAddressName">
              <strong>{this.state.dealer.dealer.toUpperCase()}</strong>
            </span>
            <br />
            <span className="dealerAddress">
              {this.state.dealer.locationName},{' '}
              {capitaliseSentence(this.state.dealer.suburb.toLowerCase())}
              {this.state.dealer.state.toUpperCase()} {this.state.dealer.postCode}
              <br />
              <strong>Dealer# </strong> {this.state.dealer.dealerCode} | <strong>Location# </strong>{' '}
              {this.state.dealer.locationCode} | <strong>DMS:</strong> {this.state.dealer.dmsName}
            </span>
            <br />
            <span className="dealerAddress">
              <strong>Site ID:</strong> {this.state.dealer.serviceSiteId}
            </span>
            <br />
            <span className="dealerAddress">
              <strong>Lead Time In Days:</strong> {this.state.dealer.leadTimeInDays}
            </span>
          </div>

          {/* Toggle Table from props.rowdata features */}
          <br />
          <DealerEdit dealer={this.state.dealer} authToken={this.state.authToken} />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(DealerEditContainer);



// WEBPACK FOOTER //
// ./src/containers/Dealers/DealerEditContainer.js